export enum Analysis {
  FAILED = 'FAILED', // 분석 오류
  PROGRESS = 'PROGRESS', // 분석 중
  COMPLETE = 'COMPLETE', // 분석 완료
}

export const analysisTypeStringMap: Record<AnalysisType, string> = {
  FAILED: '분석 오류',
  PROGRESS: '분석 중',
  COMPLETE: '분석 완료',
};

export type AnalysisType = keyof typeof Analysis;

// 신역검 분석 결과 상태
export enum Result {
  VERY_GOOD = 'VERY_GOOD',
  GOOD = 'GOOD',
  CHEER_UP = 'CHEER_UP',
}

export const resultTypeStringMap: Record<ResultType, string> = {
  VERY_GOOD: 'veryGood',
  GOOD: 'good',
  CHEER_UP: 'cheerUp',
};

export type ResultType = keyof typeof Result;
